export default {
  screens: [
    {
      type: 'intro',
      title: 'Les bijoux de sentiment',
      content:
        'Chaumet inscrit le bonheur et la vie au cœur de sa création, célébrant les instants magiques de son temps.',
      idYt: '9RbWHsnfvK0',
      videoCover: 'world/sentimental/video.jpg',
      desktop: {
        cover: 'world/sentimental/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sentimental/mobile-cover-1.jpg',
        contentStyle: { width: '100%' },
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '-27%',
          right: '0',
          left: '0',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/sentimental/perspectiveLeft.jpg',
      middleImg: 'world/sentimental/perspectiveMiddle.jpg',
      rightImg: 'world/sentimental/perspectiveRight.jpg',
      content:
        'Fusionnel comme la passion, libre comme l’amour, le nouveau Lien réinvente une séduction légère et joueuse. Comme un ruban qui s’enroule pour se nouer avec fantaisie…',
      cover: 'world/sentimental/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        cover: 'world/sentimental/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        rightImg: 'world/sentimental/perspectiveRight.jpg',
        cover: 'world/sentimental/mobile-cover-1.jpg',
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '0',
          left: '-18%',
          position: 'absolute'
        }
      },
      content:
        'Le lien apparaît dans l’histoire de la Maison dès sa création en 1780. Il s’inscrit dans la tradition des bijoux de sentiment, signes d’amitié, d’amour et de promesses.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/en/worlds/sentimental.js